import React, { useState, useEffect } from 'react';
import NotiAlertListDocument from '../NotiAlert/NotiAlertListDocument';
import axios from 'axios';
import JSZip from 'jszip';
import NotiAlert from '../NotiAlert/NotiAlert';
import NotiAlertConfirmSendmail from '../NotiAlert/NotiAlertConfirmSendmail';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import UploadIcon from '@mui/icons-material/Upload';
import {
  useGetAttachmentMutation,
  useGetCreditNoteMutation,
} from '../../services/eDocuments';
import { getStorage } from '../../utils/functions/localstorage';
import Loading from '../Loading';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import BaseButton from '../Button/BaseButton';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { useTranslation } from 'react-i18next';

export default function eDocumentsDownload({
  merchant,
  selectedRows,
  isAdmin,
  token,
  setCustomerEmail,
  customerEmail,
  handleOpenDialogUploadSlip,
  handleOnClickToPayment,
  customerName,
  roleAcc,
}) {
  const Doctype = {
    E_INVOICE: {
      NAME: 'e-invoice',
      API: 'e-invoice',
      I18N_KEY: 'app.eInvoice',
    },
    E_RECEIPT: {
      NAME: 'e-Receipt',
      API: 'e-receipt',
      I18N_KEY: 'app.eReceipt',
    },
    // E_CREDIT_NOTE: {
    //   NAME: 'e-Credit Note',
    //   API: 'e-invoice',
    // },
    // ATTACHMENT: {
    //   NAME: 'Attachment',
    //   API: 'e-invoice',
    // },
  };

  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(false);
  const accesstoken = getStorage('accesstoken');
  const [openListDocuments, setOpenListDocuments] = useState(false);
  const [listDocuments, setListDocuments] = useState(null);
  const [titleDocument, setTitleDocument] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [openDialogSuccess, setOpenDialogSuccess] = useState(false);
  const [openDialogFail, setOpenDialogFail] = useState(false);
  const [openDialogSendmail, setOpenDialogSendmail] = useState(false);
  const [snackBarLoading, setSnackbarLoading] = useState(false);
  const [errorValue, setErrorValue] = useState('');
  const [getAttachment] = useGetAttachmentMutation();
  const [getCreditNote] = useGetCreditNoteMutation();
  const [emailChange, setEmailChange] = useState('');
  const [dataCheckMail, setDataCheckmail] = useState('');
  
  // ✅ ตัวแปรเช็คสิทธิ์ Sale สำหรับ Disable ปุ่ม
  const isSaleRole = roleAcc === 'SALE' || roleAcc === 'SALES';

  const {
    value: custNO,
    federalTaxId,
    federal_hash_tax_id,
  } = useSelector((state) => state.custNO);
  const [openConfirmSendmail, setOpenConfirmSendmail] = useState(false);
  const getDocumentCustomerCode = (doc = {}) =>
    doc.customer_code ||
    doc.customer?.customer_code ||
    doc.invoice_period?.sold_to_party ||
    custNO;

  useEffect(() => {
    setEmailChange(customerEmail);
  }, [customerEmail]);

  const [options] = useState([
    { label: 'ใบแจ้งหนี้', value: 'invoice' },
    { label: 'ใบเสร็จ', value: 'receipt' },
  ]);
  const [selectedOption, setSelectedOption] = useState(options[0].value);

  const handleCheckPDFmail = async () => {
    setIsLoading(true);
    setLoadingMessage(t('app.verifyingDocuments'));
    
    const domain = roleAcc === 'ADMIN' || roleAcc === 'SUPER ADMIN' || roleAcc === 'SALE' || roleAcc === 'SALES' 
      ? process.env.REACT_APP_API_URL_admin 
      : process.env.REACT_APP_API_URL; 

    let apiUrl = '';
    if (selectedOption === 'invoice') {
      apiUrl = `${domain}/send-mail/check-pdf?type=invoice`;
    } else if (selectedOption === 'receipt') {
      apiUrl = `${domain}/send-mail/check-pdf?type=receipt`;
    }

    try {
      const body = {
        invoiceNo: selectInvoiceSendmail,
        companyCode: merchant,
        customerNo: getDocumentCustomerCode(selectedRows[0]),
      };

      const response = await axios.post(apiUrl, body);
      setOpenConfirmSendmail(true);
      setDataCheckmail(response?.data?.data);

      setOpenDialogSendmail(false);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const selectInvoiceSendmail = selectedRows.map((item) => item.invoice_no);
  const adjustTheFirstLetter = (text) =>
    text.replace(/\b\w/g, function (letter) {
      return letter.toUpperCase();
    });

  const handleOpenDialogSendmail = () => {
    if (selectedRows.length === 0) {
      setOpenAlert(true); 
    } else {
      setOpenDialogSendmail(true); 
    }
  };

  const custName = selectedRows?.map((row) => row?.customer?.customer_name);

  const sendEmail = async () => {
    setLoadingMessage('กำลังส่งเมลล์...');
    setIsLoading(true);
    let apiUrl = '';
    
    if (selectedOption === 'invoice') {
      apiUrl = `https://test-admin-npayment.inet.co.th/api/v1/send-mail/?type=invoice`;
    } else if (selectedOption === 'receipt') {
      apiUrl = `https://test-admin-npayment.inet.co.th/api/v1/send-mail/?type=receipt`;
    } else if (selectedOption === 'invoice%2Creceipt') {
      apiUrl = `https://test-admin-npayment.inet.co.th/api/v1/send-mail/?type=invoice%2Creceipt`;
    }

    try {
      const response = await axios.post(apiUrl, {
        customerEmail: 'Thanaphat.arn@gmail.com',
        invoiceNo: selectInvoiceSendmail,
        customerName: custName,
        companyCode: merchant,
      });
      setOpenDialogSendmail(false);
      setOpenDialogSuccess(true);
      setOpenAlert(false);
      setOpenConfirmSendmail(false);
      console.log('response', response.data);
    } catch (error) {
      setOpenDialogFail(true);
      setOpenConfirmSendmail(false);
      setErrorValue('เนื่องจากไม่มีเอกสาร');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnClose = () => {
    setOpenAlert(false);
    setOpenDialogSuccess(false);
    setOpenDialogFail(false);
  };

  const normalizeFiles = (payload) => {
    const file = payload?.file;
    if (Array.isArray(file)) return file;
    if (file == null) return [];
    return [file]; 
  };

  // ✅ ฟังก์ชันสำหรับทำความสะอาด Base64
  const sanitizeBase64 = (s) => {
    if (!s || typeof s !== 'string') return '';
    let t = s.trim();
    const i = t.indexOf('base64,');
    if (i !== -1) t = t.slice(i + 'base64,'.length);
    t = t.replace(/\s+/g, '').replace(/-/g, '+').replace(/_/g, '/');
    const mod = t.length % 4;
    if (mod === 2) t += '==';
    else if (mod === 3) t += '=';
    else if (mod === 1) return '';
    return t;
  };

  const firstValidBase64 = (input) => {
    if (Array.isArray(input)) {
      for (const x of input) {
        const b = sanitizeBase64(x);
        if (b) return b;
      }
      return '';
    }
    return sanitizeBase64(input);
  };

  const guessMime = (b64, explicitMime) =>
    explicitMime ||
    (b64.startsWith('JVBERi0xLj') ? 'application/pdf' : 'image/png');

  const toDataUrl = (b64, explicitMime) =>
    `data:${guessMime(b64, explicitMime)};base64,${b64}`;

  const triggerDownload = (filename, dataUrl) => {
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const eDocument = {
   downLoadZip: async (type, doc) => {
      const zip = new JSZip();
      const failedUrls = []; // เก็บ URL ที่ติด CORS (โหลดทำ Zip ไม่ได้)

      const addFileToZip = (item, fileName) => {
        return new Promise((resolve) => {
          if (!item.document) {
            resolve();
            return;
          }

          // ตรวจสอบว่าเป็น Link (http) หรือ Base64 (data:image)
          if (item.document.startsWith('http')) {
            fetch(item.document)
              .then((response) => {
                if (!response.ok) throw new Error('Network error');
                return response.blob();
              })
              .then((blob) => {
                zip.file(fileName, blob);
                resolve();
              })
              .catch((error) => {
                // ถ้า fetch ไม่ได้เพราะติด CORS ให้เอาไปพักไว้ใน failedUrls
                failedUrls.push({ url: item.document, fileName });
                resolve();
              });
          } else {
            // กรณีเป็น Base64 โหลดลง Zip ได้ปกติ 100%
            fetch(item.document)
              .then((response) => response.blob())
              .then((blob) => {
                zip.file(fileName, blob);
                resolve();
              })
              .catch(() => resolve());
          }
        });
      };
      
      // รอให้พยายามดึงไฟล์ทั้งหมดมาก่อน
      await Promise.all(
        doc.map(async (item) => {
          const fileName = `${type.toLocaleLowerCase()}-${item.invoice_no}.pdf`;
          await addFileToZip(item, fileName);
        }),
      );
      
      // --- ส่วนที่ 1: ถ้ามีไฟล์ไหนทำ Zip ได้ ก็แพ็คโหลดเป็น Zip ---
      if (Object.keys(zip.files).length > 0) {
        try {
          const blob = await zip.generateAsync({ type: 'blob' });
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = `${type.toLocaleLowerCase()}.zip`;
          downloadLink.click();
          downloadLink.remove();
        } catch (err) {
          console.error('Zip Error:', err);
        }
      }

      // --- ส่วนที่ 2: ไฟล์ที่ทำ Zip ไม่ได้ ใช้เทคนิค Hidden Iframe ดึงไฟล์ทีละใบ ---
      if (failedUrls.length > 0) {
        failedUrls.forEach((file, index) => {
          // ดีเลย์ 0.8 วินาทีต่อไฟล์ เพื่อให้บราวเซอร์รับรู้ว่าเป็นการค่อยๆ ทยอยโหลด
          setTimeout(() => {
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none'; // ซ่อนไม่ให้ User เห็น
            iframe.src = file.url;
            document.body.appendChild(iframe); // ยัดลงหน้าเว็บ (เบราว์เซอร์จะโหลดไฟล์ทันที)
            
            // ทำลาย iframe ทิ้งหลังจากผ่านไป 10 วินาที เพื่อไม่ให้ขยะรกหน้าเว็บ
            setTimeout(() => {
              if (document.body.contains(iframe)) {
                document.body.removeChild(iframe);
              }
            }, 10000);
          }, index * 800); 
        });
      }
      
      // ปิดหน้าต่าง Popup
      eDocument.closeDoc();
    },

    callApi: async (doc, type, api) => {
      const domain =
        roleAcc === 'ADMIN' || 
        roleAcc === 'SUPER ADMIN' || 
        roleAcc === 'SALE' || 
        roleAcc === 'SALES'
          ? process.env.REACT_APP_API_URL_admin
          : process.env.REACT_APP_API_URL;

      try {
        // --- 1. ลองเรียก API เส้นหลัก ---
        const url = `${domain}/reports/${api}`;
        const params = { invoiceNo: doc.invoice_no, sorgcode: doc.sorgcode };
        const { data } = await axios.get(url, { params });
        const payload = data?.data || {};
        const kind = (payload.type || type || 'document').toString().toLowerCase();

        // เช็คว่า API เส้นหลักส่งมาเป็น Link URL หรือไม่
        let pdfLink = '';
        if (Array.isArray(payload.pdfURL) && payload.pdfURL.length > 0) pdfLink = payload.pdfURL[0];
        else if (typeof payload.pdfUrl === 'string') pdfLink = payload.pdfUrl;

        if (pdfLink && pdfLink.startsWith('http')) {
           return [{
              invoice_no: doc.invoice_no,
              fileName: `${kind}-${doc.invoice_no}.pdf`,
              document: pdfLink 
           }];
        }
        
        let files = normalizeFiles(payload);
        
        // ถ้าไม่มีข้อมูล ให้โยน Error ไปเข้า Catch เพื่อเรียกเส้นสำรอง
        if (!files || files.length === 0 || !files[0]) {
           throw new Error('ไม่พบไฟล์ในเส้นหลัก');
        }

        const baseMime = 'application/pdf';

        const docs = files.map((f, i) => ({
          invoice_no: doc.invoice_no,
          fileName: files.length > 1 ? `${kind}-${doc.invoice_no}-${i + 1}.pdf` : `${kind}-${doc.invoice_no}.pdf`,
          document: `data:${baseMime};base64,${sanitizeBase64(f)}`,
        }));

        return docs;

      } catch (e) {
        // ✅ 2. เปลี่ยนเงื่อนไขให้รองรับ E-Invoice ในการดึงเส้นสำรองด้วย
        if (api === 'e-receipt' || api === 'e-invoice') {
           try {
              // กำหนด endpoint ย่อยของเส้นสำรองตามประเภทเอกสาร
              const fallbackEndpoint = api === 'e-receipt' ? 'get-ereceipt' : 'get-einvoice';
              const fallbackUrl = `${domain}/payment-be/${fallbackEndpoint}`;
              
              const fallbackResponse = await axios.post(fallbackUrl, {
                invoiceNo: doc.invoice_no
              });
              
              const fallbackData = fallbackResponse.data;
              const fallbackPayload = fallbackData?.data ?? fallbackData ?? {};
              const kind = (type || 'document').toString().toLowerCase();

              // ดักจับกรณีส่งกลับมาเป็น URL (pdfURL Array)
              if (fallbackPayload.pdfURL && fallbackPayload.pdfURL.length > 0) {
                 return [{
                    invoice_no: doc.invoice_no,
                    fileName: `${kind}-${doc.invoice_no}.pdf`,
                    document: fallbackPayload.pdfURL[0] // ใส่ URL ให้ fetch ไปดาวน์โหลดและ zip ได้เลย
                 }];
              }

              // ดักจับกรณีส่งกลับมาเป็น Base64
              let fallbackBase64 = fallbackPayload.file ?? fallbackPayload.File ?? fallbackPayload.base64 ?? '';
              if (Array.isArray(fallbackBase64)) fallbackBase64 = fallbackBase64[0];

              if (fallbackBase64) {
                 return [{
                    invoice_no: doc.invoice_no,
                    fileName: `${kind}-${doc.invoice_no}.pdf`,
                    document: `data:application/pdf;base64,${sanitizeBase64(fallbackBase64)}`
                 }];
              }
           } catch (errFallback) {
              console.error(`Fallback API Failed for ${api}:`, errFallback);
           }
        }
        
        // ถ้าหาไม่เจอจริงๆ ทั้ง 2 เส้น ให้คืนค่า null เพื่อแสดงกากบาทสีแดง
        return [{ invoice_no: doc.invoice_no, document: null }];
      }
    },

    closeDoc: () => {
      setOpenListDocuments(false);
    },
    
    // --- โหลดเดี่ยว eInvoice ---
    eInvoice: async (doc) => {
      setIsLoading(true);
      setLoadingMessage(t('app.verifyingDocuments'));

      const domain =
        roleAcc === 'ADMIN' || roleAcc === 'SUPER ADMIN' || roleAcc === 'SALE' || roleAcc === 'SALES'
          ? process.env.REACT_APP_API_URL_admin
          : process.env.REACT_APP_API_URL;

      try {
        const apiUrl = `${domain}/reports/e-invoice/?invoiceNo=${doc.invoice_no}&sorgcode=${doc.sorgcode}&customerCode=${getDocumentCustomerCode(doc)}&customerName=${customerName}`;

        const { data } = await axios.get(apiUrl);

        if (data?.data?.status === 'Not Found') throw new Error('ไม่พบไฟล์เส้นหลัก');

        const payload = data?.data ?? data ?? {};

        // เช็คว่า API เส้นหลักส่งมาเป็น Link URL
        let pdfLink = '';
        if (Array.isArray(payload.pdfURL) && payload.pdfURL.length > 0) pdfLink = payload.pdfURL[0];
        else if (typeof payload.pdfUrl === 'string') pdfLink = payload.pdfUrl;

        if (pdfLink && pdfLink.startsWith('http')) {
          triggerDownload(`e-invoice-${doc.invoice_no}.pdf`, pdfLink);
          return; 
        }

        const raw = firstValidBase64(
          payload.file ?? payload.File ?? payload.files ?? '',
        );

        if (!raw) throw new Error('ไม่พบไฟล์ e-invoice เส้นหลัก');

        triggerDownload(
          `e-invoice-${doc.invoice_no}.pdf`,
          toDataUrl(raw, 'application/pdf'),
        );
      } catch (error) {
        // ✅ ระบบ Fallback เส้นที่สองของ eInvoice
        try {
          const fallbackUrl = `${domain}/payment-be/get-einvoice`;
          const fallbackResponse = await axios.post(fallbackUrl, {
            invoiceNo: doc.invoice_no
          });

          const fallbackData = fallbackResponse.data;
          const fallbackPayload = fallbackData?.data ?? fallbackData ?? {};
          
          if (fallbackPayload.pdfURL && fallbackPayload.pdfURL.length > 0) {
            const pdfLink = fallbackPayload.pdfURL[0];
            if (pdfLink.startsWith('http')) {
              triggerDownload(`e-invoice-${doc.invoice_no}.pdf`, pdfLink);
              return; 
            }
          }

          const fallbackRaw = firstValidBase64(
            fallbackPayload.file ?? fallbackPayload.File ?? fallbackPayload.base64 ?? '',
          );

          if (!fallbackRaw) throw new Error('ไม่มีข้อมูล e-invoice จากทั้งสองเส้นทาง');

          triggerDownload(
            `e-invoice-${doc.invoice_no}.pdf`,
            toDataUrl(fallbackRaw, 'application/pdf'),
          );

        } catch (fallbackError) {
          const errorMsg = fallbackError?.response?.data?.error?.message || 
                           fallbackError?.response?.data?.message ||
                           fallbackError?.message || 
                           'เกิดข้อผิดพลาดในการดาวน์โหลดใบแจ้งหนี้';
          
          setOpenAlert(true);
          setErrorValue(errorMsg);
          setOpenDialogFail(true);
        }
      } finally {
        setIsLoading(false);
      }
    },

    // --- โหลดเดี่ยว eReceipt ---
    eReceipt: async (doc) => {
      setIsLoading(true);
      setLoadingMessage(t('app.verifyingDocuments'));

      const domain =
        roleAcc === 'ADMIN' || roleAcc === 'SUPER ADMIN' || roleAcc === 'SALE' || roleAcc === 'SALES'
          ? process.env.REACT_APP_API_URL_admin
          : process.env.REACT_APP_API_URL;

      try {
        const apiUrl = `${domain}/reports/e-receipt/?invoiceNo=${doc.invoice_no}&sorgcode=${doc.sorgcode}&customerCode=${getDocumentCustomerCode(doc)}&customerName=${customerName}`;

        const { data } = await axios.get(apiUrl);
        const payload = data?.data ?? data ?? {};
        const raw = firstValidBase64(
          payload.file ?? payload.File ?? data?.pdfUrl ?? '',
        );

        if (!raw) {
          throw new Error('ไม่พบไฟล์จากเส้นทางหลัก'); 
        }

        triggerDownload(
          `e-receipt-${doc.invoice_no}.pdf`,
          toDataUrl(raw, 'application/pdf'),
        );

      } catch (error) {
        try {
          const fallbackUrl = `${domain}/payment-be/get-ereceipt`;
          const fallbackResponse = await axios.post(fallbackUrl, {
            invoiceNo: doc.invoice_no
          });

          const fallbackData = fallbackResponse.data;
          const fallbackPayload = fallbackData?.data ?? fallbackData ?? {};
          
          if (fallbackPayload.pdfURL && fallbackPayload.pdfURL.length > 0) {
            const pdfLink = fallbackPayload.pdfURL[0];
            if (pdfLink.startsWith('http')) {
              triggerDownload(`e-receipt-${doc.invoice_no}.pdf`, pdfLink);
              return; 
            }
          }

          const fallbackRaw = firstValidBase64(
            fallbackPayload.file ?? fallbackPayload.File ?? fallbackPayload.base64 ?? '',
          );

          if (!fallbackRaw) {
            throw new Error('ไม่มีข้อมูล e-receipt จากทั้งสองเส้นทาง');
          }

          triggerDownload(
            `e-receipt-${doc.invoice_no}.pdf`,
            toDataUrl(fallbackRaw, 'application/pdf'),
          );

        } catch (fallbackError) {
          const errorMsg = fallbackError?.response?.data?.error?.message || 
                           fallbackError?.response?.data?.message ||
                           fallbackError?.message || 
                           'เกิดข้อผิดพลาดในการดาวน์โหลดเอกสารใบเสร็จ';
          
          setOpenAlert(true);
          setErrorValue(errorMsg);
          setOpenDialogFail(true);
        }
      } finally {
        setIsLoading(false);
      }
    },

    callApiAttachment: async ({ so_number, accesstoken }) => {
      try {
        const data = await getAttachment({
          so_number,
          accesstoken,
        }).unwrap();
        const imageType = {
          fileExtension: 'png',
          typeBase: 'image',
        };
        const pdfType = {
          fileExtension: 'pdf',
          typeBase: 'pdf',
        };
        const PDF_TYPE = 'JVBERi0xLj';
        const checkType = data.result.startsWith(PDF_TYPE)
          ? { ...pdfType }
          : { ...imageType };
        const base64 = `data:application/${checkType.typeBase};base64,${data.result}`;
        const fileName = `attachment-${so_number}.${checkType.fileExtension}`;
        return {
          invoice_no: so_number,
          fileName,
          document: base64,
        };
      } catch (error) {
        return {
          invoice_no: so_number,
          document: null,
        };
      }
    },

    callApiCredit: async ({ get_cn, invoice_no, accesstoken, sorgcode }) => {
      try {
        if (get_cn === '') throw '';
        const data = await getCreditNote({
          get_cn,
          accesstoken,
          sorgcode,
          invoice_no,
        }).unwrap();
        const imageType = {
          fileExtension: 'png',
          typeBase: 'image',
        };
        const pdfType = {
          fileExtension: 'pdf',
          typeBase: 'pdf',
        };
        const PDF_TYPE = 'JVBERi0xLj';
        const checkType = data.result.startsWith(PDF_TYPE)
          ? { ...pdfType }
          : { ...imageType };
        const base64 = `data:application/${checkType.typeBase};base64,${data.result}`;
        const fileName = `e-credit-note-${invoice_no}.${checkType.fileExtension}`;
        return {
          invoice_no: invoice_no,
          fileName,
          document: base64,
        };
      } catch (error) {
        return {
          invoice_no:
            get_cn === ''
              ? `ไม่พบ E-Credit Note ของ ${invoice_no}`
              : invoice_no,
          document: null,
        };
      }
    },

    uniqueData: (i) =>
      i.reduce(
        (acc, item) => {
          if (!acc.so_number.has(item.so_number)) {
            acc.so_number.add(item.so_number);
            acc.result.push(item);
          }
          return acc;
        },
        { so_number: new Set(), result: [] },
      ).result,

    main: async (type) => {
      try {
        if (selectedRows.length === 0) throw 'ไม่มีข้อมูล';
        setIsLoading(true);

        const responses = await Promise.all(
          selectedRows.map((item) =>
            eDocument.callApi(
              { invoice_no: item.invoice_no, sorgcode: item.sorgcode },
              type.NAME,
              type.API,
            ),
          ),
        );
        setListDocuments(responses.flat());

        setTitleDocument(t(type.I18N_KEY));

        setOpenListDocuments(true);
      } catch (error) {
        console.log('Error:', error);
        setOpenAlert(true);
      } finally {
        setIsLoading(false);
      }
    },
  };

  return (
    <div className="flex flex-col gap-4 md:flex-row md:flex-wrap md:flex-0">
      {Object.entries(Doctype).map(([key, value]) => (
        <BaseButton
          key={key}
          variant="contained"
          text={t(value.I18N_KEY)}
          onClick={() => eDocument.main(value)}
          disabled={isSaleRole} // ✅ ปิดปุ่มสำหรับ SALE Role
        />
      ))}
      {isAdmin && (
        <>
          <BaseButton
          text={t('app.toPay')}
            icon={<HourglassEmptyIcon />}
            onClick={handleOnClickToPayment}
            variant="contained"
          />
          <BaseButton
            text={t('app.sendEmail')}
            icon={<ForwardToInboxIcon />}
            onClick={handleOpenDialogSendmail}
            variant="contained"
          />
          <BaseButton
            text={t('app.uploadSlip')}
            icon={<UploadIcon />}
            onClick={handleOpenDialogUploadSlip}
            variant="contained"
          />
        </>
      )}

      <Backdrop
        open={isLoading}
        sx={{
          color: '#fff',
          zIndex: 9999, 
        }}
      >
        <CircularProgress color="inherit" />
        <span style={{ marginLeft: '1rem', fontSize: '1.2rem' }}>
          {loadingMessage}
        </span>
      </Backdrop>

      <NotiAlertListDocument
        open={openListDocuments}
        document={listDocuments}
        selectedRows={selectedRows}
        onButtonClick={eDocument.closeDoc}
        titleDocument={titleDocument}
        downLoadZip={eDocument.downLoadZip}
      />
      <NotiAlert
        open={openAlert}
        setOpen={setOpenAlert}
        title={t('app.pleaseSelectInvoice')} 
        value="error"
        onButtonClick={handleOnClose}
      />

      <NotiAlertConfirmSendmail
      t={t}
        snackBarLoading={snackBarLoading}
        options={options}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        selectedRows={selectedRows}
        setOpenDialogSendmail={setOpenDialogSendmail}
        openDialogSendmail={openDialogSendmail}
        onButtonClickSendmail={sendEmail}
        customerEmail={customerEmail}
        openConfirmSendmail={openConfirmSendmail}
        setOpenConfirmSendmail={setOpenConfirmSendmail}
        handleCheckPDFmail={handleCheckPDFmail}
        dataCheckMail={dataCheckMail}
        isLoading={isLoading}
        setLoadingMessage={setLoadingMessage}
        loadingMessage={loadingMessage}
      />
      <NotiAlert
        open={openDialogSuccess}
        title={`ส่ง Request ${
          selectedOption === 'invoice'
            ? 'ใบแจ้งหนี้'
            : selectedOption === 'receipt'
            ? 'ใบเสร็จ'
            : selectedOption === 'invoice&receipt'
            ? 'ใบแจ้งหนี้และใบเสร็จ'
            : ''
        } เรียบร้อย`}
        value="success"
        onButtonClick={handleOnClose}
        selectedOption={selectedOption}
      />
      <NotiAlert
        setErrorValue={setErrorValue}
        errorValue={errorValue}
        open={openDialogFail}
        title="การส่งอีเมลไม่สำเร็จ"
        value="cancel"
        onButtonClick={handleOnClose}
      />
    </div>
  );
}
